import { getBaseUrl, getJirItemUrl, isGmailContext, isJiraContext } from "./api/api";
import TaskAction from "./actions/TaskAction";
import { ContentTypes } from "./constants/action-types";

export const navigateTo = ({
  jiraUrlParams,
  jiraView = "site",
  appUrl,
  navigate,
  forceUseNavigate = false,
}) => {
  if (forceUseNavigate && jiraView != "issue") {
    navigate(appUrl);
  } else if (isJiraContext()) {
    AP.navigator.go(jiraView, jiraUrlParams);
  } else {
    if (jiraView != "issue") {
      navigate(appUrl);
    }
  }
};

export const navigateToItem = ({ item, navigate }) => {
  const appUrl = `/workspaces/${item.get("projectId")}/items/${item.get("id")}?type=${item.get(
    "type"
  )}`;
  const jiraUrl = getJirItemUrl({
    workspaceId: item.get("projectId"),
    itemId: item.get("id"),
    type: item.get("type"),
    view: "BOARD",
  });
  if (item.get("type") === ContentTypes.TASK || item.get("type") === ContentTypes.ISSUE) {
    navigateTo({
      jiraUrlParams: { issueKey: item.get("id") },
      appUrl,
      navigate,
      jiraView: "issue",
    });
  } else {
    navigateTo({
      jiraUrlParams: { relativeUrl: jiraUrl },
      appUrl,
      navigate,
    });
  }
};

export const connectRedirectUrlAppIntegration = (projectId: string, appId: string) => {
  let postUrl = `${getBaseUrl()}/workspaces/${projectId}/settings/apps?key=Apps&appId=${appId}`;
  if (isJiraContext()) {
    postUrl = `/plugins/servlet/ac/salecrmjira/workspace?ac.workspaceId=${projectId}&ac.suffix=apps&ac.key=Apps&ac.appId=${appId}`;
  }
  if (isGmailContext()) {
    const origin = window.location.origin;
    const pathname = window.location.pathname;
    postUrl = `${origin}/${pathname}#/typecrm/workspaces/${projectId}/settings/apps?key=Apps&appId=${appId}`;
  }
  return postUrl;
};

export const connectRedirectUrlAiContent = (projectId: string, appId: string, view: string) => {
  let postUrl = `${getBaseUrl()}/workspaces/${projectId}/ai-content?key=AI%20Content&appId=${appId}&view=${view}`;
  if (isJiraContext()) {
    postUrl = `/plugins/servlet/ac/salecrmjira/workspace?ac.workspaceId=${projectId}&ac.suffix=ai-content&ac.key=AI%20Content&ac.appId=${appId}&ac.view=${view}`;
  }
  if (isGmailContext()) {
    const origin = window.location.origin;
    const pathname = window.location.pathname;
    postUrl = `${origin}/${pathname}#/typecrm/workspaces/${projectId}/ai-content?key=AI%20Content&appId=${appId}&view=${view}`;
  }
  return postUrl;
};

interface ItemForm {
  projectId: string;
  type: string;
  data?: any;
  projectView?: string;
}
interface CreateItemFormType {
  dispatch?: any;
  item?: ItemForm;
  type: string;
  useInApp?: boolean;
  onClose: any;
}

export const showCreateItemDialog = ({
  dispatch = () => {},
  item,
  type,
  useInApp: _useInApp = true,
  onClose: _onClose = () => {},
}: CreateItemFormType) => {
  dispatch(TaskAction.showTaskDialog(item, type));
};
